exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "button.pre-intake--3gp91p-wtuok5Bm8rX1iFI {\n  font-size: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"editButton": "pre-intake--3gp91p-wtuok5Bm8rX1iFI",
	"editButton": "pre-intake--3gp91p-wtuok5Bm8rX1iFI"
};